import {Box, Typography} from '@mui/material'
import React from 'react'

export default function Implementation_committees() {
    return (
        <Box paddingY={5}>
            <Typography
                variant="h6"
                textAlign={"center"}
                fontFamily={"Prompt"}
                // fontStyle={"italic"}
                fontWeight={"bold"}
                color={"secondary.dark"}
                marginTop="10px"
            >
                IMPLEMENTATION COMMITTEES
            </Typography>

            <div className="container mt-4">
                <div className="row">
                    <div className="row">

                        <div className="col-md-6 col-sm-12 col-xs-12">

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Publicity, Creatives, and Outreach</Typography>
                            <strong>
                                Prof. Abhinav Kranti, IIT Indore<br />
                                Dr.Abhishek Srivastava, IIT Indore
                            </strong>
                            <br />
                            <br />

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Skill Center</Typography>
                            <strong>
                                Dr. Bhargav Vaidya, IIT Indore
                            </strong>

                            <br />
                            <br />

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Technology Development</Typography>
                            <strong>
                                Prof. Abhinav Kranti, IIT Indore<br />
                                Dr.Abhishek Srivastava, IIT Indore
                            </strong>
                            <br />
                            <br />

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Technology Business Incubator (TBI)</Typography>
                            <strong>
                                Dr. Bhargav Vaidya, IIT Indore<br />
                                Dr.Abhishek Srivastava, IIT Indore
                            </strong>
                            <br />
                            <br />


                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Policy Formulation</Typography>
                            <strong>
                                Dr. Kiran Bala, IIT Indore<br />
                                Prof.Sandeep Chaudhary, IIT Indore
                            </strong>

                            <br />
                            <br />
                        </div>

                        <div className="col-md-6 col-sm-12 col-xs-12">

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >International Collaboration</Typography>
                            <strong>
                                Dr. Abhishek Srivastava, IIT Indore
                            </strong>
                            <br />
                            <br />


                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Coordination with Spokes</Typography>
                            <strong>
                                Dr. Kiran Bala, IIT Indore
                            </strong>
                            <br />
                            <br />

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >Coordination with Industry</Typography>
                            <strong>
                                Prof. Sandeep Chaudhary, IIT Indore
                            </strong>
                            <br />
                            <br />

                            <Typography
                                variant='h6'
                                fontFamily='Prompt'
                                fontWeight='bold'
                                color='primary.dark' >CHANAKYA Fellowships</Typography>
                            <strong>
                                Dr. Bhargav Vaidya, IIT Indore<br />
                                Prof. Abhinav Kranti, IIT Indore<br />
                                Dr. Kiran Bala, IIT Indore
                            </strong>


                            <div>
                            </div>

                        </div>
                    </div></div></div>
        </Box>
    )
}
